import React from "react";
import module from "./TopGreen.module.css";

const TopGreen = ({ children, overrideClass }) => {
  return (
    <div
      className={overrideClass ? `${module.top} ${overrideClass}` : module.top}
    >
      {children}
    </div>
  );
};

export default TopGreen;
